import React, { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useNavigate } from "react-router-dom";
//translation
import { useTranslation } from "react-i18next";

import BookingCalendar from "components/calendar/BookingCalendar";

export interface StayCardHProps {
  className?: string;
  data?: any;
  availabilities?: any;
}

const StayCardAlternative: FC<StayCardHProps> = ({
  className = "",
  data,
  availabilities,
}) => {
  const { galleryImgs, id } = data;

  const trimmedPrice = data.price.replace(/[^\d.]/g, "").trim();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleCardClick = () => {
    if (id) {
      navigate(`/listings-list/${id}`);
    }
  };

  const renderTienIch = () => {
    return (
      <div className="flex flex-col h-full space-y-4">
        {/* Guest Information */}
        <div className="flex items-center space-x-3">
          <i className="las la-user text-lg"></i>
          <span className="text-sm text-neutral-500 dark:text-neutral-400">
            {data?.moreinfo?.max_people} guests
          </span>
        </div>

        {/* Title */}
        <h2 className="text-xl font-semibold text-neutral-800 dark:text-neutral-200">
          {data.title}
        </h2>

        {/* Address */}
        <p className="text-sm text-neutral-500 dark:text-neutral-400">
          {data.address.full}
        </p>

        {/* Bottom-Aligned Button */}
        <div className="mt-auto">
          <ButtonPrimary
            className="w-full px-4 py-2 bg-primary text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition"
            onClick={handleCardClick}
          >
            See Details
          </ButtonPrimary>
        </div>
      </div>
    );
  };
  const renderSliderGallery = () => {
    return (
      <div className="flex flex-col gap-6 items-center">
        {/* Display the First Image */}
        <div className="relative w-full max-w-[500px]">
          {/* Image */}
          <img
            src={galleryImgs[0]}
            alt="Gallery"
            className="w-full h-auto max-h-[400px] rounded-lg object-cover"
          />

          {/* Price Overlay */}
          <div className="absolute bottom-4 right-4 bg-black bg-opacity-75 text-white text-lg font-semibold px-3 py-1 rounded-lg shadow-lg">
            {trimmedPrice}/night
          </div>
        </div>

        {/* Render Tien Ich */}
        <div className="w-full max-w-[500px] px-4">{renderTienIch()}</div>
      </div>
    );
  };

  return (
    <div
      className={`nc-StayCardH group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow will-change-transform ${className}`}
      data-nc-id="StayCardH"
    >
      <div className="flex flex-col md:flex-row gap-4 pb-6">
        {renderSliderGallery()}
        <div className="bookingCalendar__wrap overflow-hidden ">
          <h2 className="text-2xl font-semibold text-center md:text-left mb-6">
            {t("Availabilities")}
          </h2>
          <BookingCalendar availabilities={availabilities || [""]} />
        </div>
      </div>
    </div>
  );
};

export default StayCardAlternative;
